import { useQuery } from "@tanstack/react-query";
import type { SAMGroup } from "../types/role.types";
import * as samApi from "../api/samApi";

/**
 * Hook to fetch and manage Cognito groups
 * Uses SAM API which already filters groups to only show those with "business" prefix
 */
export const useRoles = () => {
  // Fetch all business groups from SAM API
  const { data, isLoading, error } = useQuery({
    queryKey: ['sam-groups'],
    queryFn: async () => {
      try {
        const response = await samApi.listBusinessGroups() as unknown as samApi.ListGroupsResponse;
        return response.groups;
      } catch (error: any) {
        console.error('Error fetching SAM groups:', error);
        throw error;
      }
    },
  });

  const businessGroups: SAMGroup[] = data || [];

  return {
    businessGroups,
    isLoading,
    error,
  };
};
